export const FETCH_ASSISTANTURL_REQUEST = "FETCH_ASSISTANTURL_REQUEST";
export const FETCH_ASSISTANTURL_SUCCESS = "FETCH_ASSISTANTURL_SUCCESS";
export const FETCH_ASSISTANTURL_ERROR = "FETCH_ASSISTANTURL_ERROR";
export const HANDLE_ASSISTANT_AUTHENTICATION_FAILURE =
  "HANDLE_ASSISTANT_AUTHENTICATION_FAILURE";
export const ASSISTANT_NAVIGATION_REQUEST = "ASSISTANT_NAVIGATION_REQUEST";
export const ASSISTANT_NAVIGATION_SUCCESS = "ASSISTANT_NAVIGATION_SUCCESS";
export const ASSISTANT_NAVIGATION_CLEAR = "ASSISTANT_NAVIGATION_CLEAR";

export const DRUG_NAVIGATION_FALLBACK_PATH = "/results?q=";
export const DRUG_NAVIGATION_FALLBACK_TYPE = "search";
